module.exports = "https://web-assets.ifttt.com/packs/media/home/applet-ex-8238b554.png";